import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns locale string from page state
 */
export default function useLocale() {
    return useAppSelector((state) => state?.page.locale)
}